<template lang="pug">
.error
  | {{ message }}
</template>

<script>

import * as Sentry from '@sentry/browser';

export default {
  props: {
    message: { type: String, default: 'Unable to display attachment' },
    attachment: Object,
  },
  mounted() {
    const error = `ErrorAttachment mounted, bad attachment: ${JSON.stringify(this.attachment)}`;
    Sentry.captureMessage(error, 'error');
  },
};
</script>

<style lang="scss" scoped>
.error {
  font-size: 0.6em;
  color: #ddd;
  padding-top: 0.3em;
  padding-bottom: 0.3em;
  width: 100%;
}
</style>
